(function () {
  function setupCompactHeader() {
    var desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    document.querySelectorAll('.cp-compact-header details').forEach(function (dropdown) {
      var closeTimer;
      dropdown.addEventListener('mouseenter', function () {
        if (!desktopPointer.matches) return;
        window.clearTimeout(closeTimer);
        dropdown.open = true;
      });
      dropdown.addEventListener('mouseleave', function () {
        if (!desktopPointer.matches) return;
        closeTimer = window.setTimeout(function () { dropdown.open = false; }, 120);
      });
      dropdown.addEventListener('focusout', function (event) {
        if (!desktopPointer.matches) return;
        if (!dropdown.contains(event.relatedTarget)) dropdown.open = false;
      });
    });
  }
  function setupMobileCollectionMenus() {
    var mobile = window.matchMedia('(max-width: 949px)');
    var hoverableMouse = window.matchMedia('(max-width: 949px) and (hover: hover) and (pointer: fine)');
    if (!mobile.matches) return;
    document.querySelectorAll('body.template-collection .cp-menu').forEach(function (menu) {
      var closeTimer;
      function closeSoon() {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () { menu.open = false; }, 120);
      }
      menu.addEventListener('mouseenter', function () {
        if (hoverableMouse.matches) {
          window.clearTimeout(closeTimer);
          menu.open = true;
        }
      });
      menu.addEventListener('mouseleave', function () {
        if (hoverableMouse.matches) closeSoon();
      });
      document.addEventListener('pointerdown', function (event) {
        if (!menu.contains(event.target)) menu.open = false;
      });
    });
  }
  function setup() {
    setupCompactHeader();
    setupMobileCollectionMenus();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();


/* CP adaptive compact header sizing. */
(function () {
  var MIN_WIDTH = 950;
  var MAX_WIDTH = 989;
  var MAX_GAP = 60;
  var MIN_GAP = 35;
  var MAX_FONT = 24;
  var MIN_FONT = 20;
  var frameId = 0;

  function isDesktopAdaptiveRange() {
    var widthMatch = window.innerWidth >= MIN_WIDTH;
    var landscapePhone = window.matchMedia(
      '(max-height: 500px) and (orientation: landscape) and (hover: none) and (pointer: coarse)'
    ).matches;
    return widthMatch && !landscapePhone;
  }

  function setNumber(header, name, value) {
    header.style.setProperty(name, Math.round(value * 100) / 100 + 'px');
  }

  function visibleGroups(header, nav, logo, tools) {
    var groups = Array.prototype.slice.call(nav.children);
    return groups.filter(function (element) {
      return element && window.getComputedStyle(element).display !== 'none';
    });
  }

  function groupWidth(groups) {
    return groups.reduce(function (total, element) {
      return total + element.getBoundingClientRect().width;
    }, 0);
  }

  function fitHeader(header) {
    var logo = header.querySelector('.cp-compact-header__logo');
    var nav = header.querySelector('.cp-compact-header__nav');
    var tools = header.querySelector('.cp-compact-header__tools');
    if (!logo || !nav || !tools) return;

    if (!isDesktopAdaptiveRange()) {
      header.classList.remove('cp-compact-header--adaptive');
      header.style.removeProperty('--cp-compact-gap');
      header.style.removeProperty('--cp-compact-font-size');
      return;
    }

    header.classList.add('cp-compact-header--adaptive');
    setNumber(header, '--cp-compact-font-size', MAX_FONT);
    setNumber(header, '--cp-compact-gap', MIN_GAP);

    var groups = visibleGroups(header, nav, logo, tools);
    var spaces = Math.max(1, groups.length - 1);
    var style = window.getComputedStyle(header);
    var navStyle = window.getComputedStyle(nav);
    var usableWidth = nav.clientWidth - parseFloat(navStyle.paddingLeft) - parseFloat(navStyle.paddingRight);
    var naturalWidth = groupWidth(groups);
    var availableGap = (usableWidth - naturalWidth) / spaces;

    if (availableGap >= MIN_GAP) {
      setNumber(header, '--cp-compact-gap', Math.min(MAX_GAP, availableGap));
      return;
    }

    setNumber(header, '--cp-compact-gap', MIN_GAP);
    var targetWidth = usableWidth - spaces * MIN_GAP;
    var low = MIN_FONT;
    var high = MAX_FONT;

    setNumber(header, '--cp-compact-font-size', low);
    if (groupWidth(groups) > targetWidth) return;

    for (var i = 0; i < 9; i += 1) {
      var middle = (low + high) / 2;
      setNumber(header, '--cp-compact-font-size', middle);
      if (groupWidth(groups) <= targetWidth) low = middle;
      else high = middle;
    }
    setNumber(header, '--cp-compact-font-size', low);
  }

  function fitAllHeaders() {
    document.querySelectorAll('.cp-compact-header').forEach(fitHeader);
  }

  function scheduleFit() {
    window.cancelAnimationFrame(frameId);
    frameId = window.requestAnimationFrame(fitAllHeaders);
  }

  function setupAdaptiveHeaders() {
    fitAllHeaders();

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(scheduleFit);
      document.querySelectorAll('.cp-compact-header').forEach(function (header) {
        resizeObserver.observe(header);
      });
    } else {
      window.addEventListener('resize', scheduleFit);
    }

    document.querySelectorAll('.cp-compact-header__nav').forEach(function (nav) {
      new MutationObserver(scheduleFit).observe(nav, { childList: true });
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleFit);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAdaptiveHeaders);
  } else {
    setupAdaptiveHeaders();
  }
})();
